import { render, staticRenderFns } from "./MoviesEight.vue?vue&type=template&id=368220de&scoped=true&"
import script from "./MoviesEight.vue?vue&type=script&lang=js&"
export * from "./MoviesEight.vue?vue&type=script&lang=js&"
import style0 from "./MoviesEight.vue?vue&type=style&index=0&id=368220de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368220de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
